<template>
  <section
    v-if="!parentType"
    :id
    class="paragraph-text container my-spacing-md"
  >
    <!-- eslint-disable-next-line vuejs-accessibility/click-events-have-key-events vuejs-accessibility/no-static-element-interactions -->
    <div
      v-blokkli-editable:field_body
      :class="[
        classes,
        {
          'gap-4 tablet:columns-2': options.twoColumns,
        },
      ]"
      class="ck-content content"
      @click.capture="onClickText"
      v-html="text"
    />
  </section>
  <!-- eslint-disable-next-line vuejs-accessibility/click-events-have-key-events vuejs-accessibility/no-static-element-interactions -->
  <div
    v-else
    v-blokkli-editable:field_body
    :class="classes"
    class="ck-content content my-spacing-base first:mt-0 last:mb-0"
    @click.capture="onClickText"
    v-html="text"
  />
</template>

<script lang="ts" setup>
import type { ParagraphTextFragment } from '#graphql-operations'
import { isDrupalRouted } from '~/helpers/path'

defineProps<ParagraphTextFragment>()

const { parentType, options, index, siblings } = defineBlokkli({
  bundle: 'text',
  globalOptions: ['bkHiddenGlobally', 'publicationChannels'],
  options: {
    isHighlighted: {
      type: 'checkbox',
      label: 'Hervorgehoben',
      default: false,
    },
    twoColumns: {
      type: 'checkbox',
      label: 'Zwei Spalten',
      default: false,
    },
  },
  editor: {
    addBehaviour: 'no-form',
    previewWidth: 800,
    determineVisibleOptions: function (ctx) {
      if (ctx.parentType) {
        return ['isHighlighted', 'bkHiddenGlobally', 'publicationChannels']
      }
      return [
        'isHighlighted',
        'twoColumns',
        'publicationChannels',
        'bkHiddenGlobally',
      ]
    },
  },
})

const id = useParagraphAnchorId(index, siblings)
const { onClick } = useClickTriggerProxy()

function onClickText(e: MouseEvent | KeyboardEvent) {
  if (!e.target || !('href' in e.target)) {
    return
  }
  const target = e.target
  const href = target.href
  if (typeof href === 'string' && isDrupalRouted(href)) {
    return
  }

  onClick(e)
}

const classes = computed<string[]>(() => {
  if (options.value.isHighlighted) {
    return ['bg-highlighted', 'p-size-6']
  }

  return []
})
</script>

<style>
@reference '~/assets/css/tailwind.css';
.paragraph-title + .paragraph-text {
  @apply mt-0;
}

.paragraph-text + .paragraph-text {
  @apply mt-spacing-base;
}
</style>
